module.exports = __webpack_public_path__ + "31bff13faabc546ea52d3f365fc542bf.jpg";